module.exports = __webpack_public_path__ + "img/asset_SRM.76e94181.svg";